import * as React from 'react';

export const VideoErrorIcon = () => (
  <svg
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="video-error-icon"
  >
    <path
      d="M9 28C9 21.3726 14.3726 16 21 16H50C59.9411 16 68 24.0589 68 34V42C68 53.598 58.598 63 47 63H27C17.0589 63 9 54.9411 9 45V28Z"
      fill="#FFEEEE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.7184 11.5123C9.84432 13.4335 4 20.5343 4 29V41C4 50.9411 12.0589 59 22 59H45.1355L43.9808 57H22C13.1634 57 6 49.8366 6 41V29C6 21.2713 11.4798 14.8225 18.7661 13.327L17.7184 11.5123ZM50.533 56.3488C57.1619 54.3942 62 48.2621 62 41V29C62 20.1634 54.8366 13 46 13H25.5056L24.3509 11H46C55.9411 11 64 19.0589 64 29V41C64 49.0013 58.7794 55.7832 51.5587 58.1253L50.533 56.3488Z"
      fill="#EB5F5F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.1825 24.4405L22.6764 23.5398C21.3733 23.0715 20 24.0373 20 25.422V45.578C20 46.9628 21.3733 47.9285 22.6764 47.4602L35.7586 42.7588L34.7424 40.9987L22 45.578V25.422L26.7307 27.1221L25.1825 24.4405ZM40.4801 38.9367L50.0432 35.5L35.4728 30.2638L33.9246 27.5822L50.7196 33.6179C52.4844 34.2521 52.4844 36.7479 50.7196 37.3822L41.4963 40.6968L40.4801 38.9367Z"
      fill="#EB5F5F"
    />
    <path
      d="M18 6L51 63.1577"
      stroke="#EB5F5F"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
